<script setup lang="ts">
import { useQuery, useResult } from "@vue/apollo-composable";
import gql from "graphql-tag";
import { useAuthStore } from "@/stores/auth";
import { useRoute } from "vue-router";
import { computed } from "vue";

const authStore = useAuthStore();
const route = useRoute();

const { loading, error, result } = useQuery(
  gql`
    query myNotifications($after: String, $first: Int) {
      myNotifications(after: $after, first: $first) {
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          id
          broadcastMessageId
          userId
          wasViewed
          title
          body
          createdAt
        }
      }
    }
  `,
  {},
  {
    fetchPolicy: "no-cache",
  }
);

const notifications = useResult(result, null, (data) => {
  return data.myNotifications;
});

const numberNewNotification2 = computed(() => {
  if (!notifications?.value?.nodes) {
    return 0;
  }
  const newNotifications = (notifications.value.nodes as any[]).filter(
    (node) => !node.wasViewed
  );
  return newNotifications.length;
});
</script>

<template>
  <div class="tab-bar-mobile d-block d-md-none">
    <div>
      <div class="row justify-content-around">
        <div class="col-1">
          <div class="menu-item">
            <router-link active-class="active" to="/">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1em"
                height="1em"
                fill="currentColor"
                class="bi bi-house"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
                />
                <path
                  fill-rule="evenodd"
                  d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
                />
              </svg>
            </router-link>
          </div>
        </div>
        <div class="col-1">
          <div class="menu-item">
            <span class="icon-with-badge">
              <router-link active-class="active" to="/notifications">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  class="bi bi-bell"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z"
                  />
                </svg>
              </router-link>
              <span v-if="numberNewNotification2 >= 10" class="badge">9+</span>
              <span v-else-if="numberNewNotification2 <= 0"></span>
              <span v-else class="badge">{{ numberNewNotification2 }}</span>
            </span>
          </div>
        </div>
        <div class="col-1">
          <div class="menu-item">
            <router-link active-class="active" to="/user/my-personal-data">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1em"
                height="1em"
                fill="currentColor"
                class="bi bi-person-circle"
                viewBox="0 0 16 16"
              >
                <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                <path
                  fill-rule="evenodd"
                  d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                />
              </svg>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.tab-bar-mobile {
  height: 77px;
}

.tab-bar-mobile > div {
  display: block;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: var(--black-eigengrau);
  color: var(--white-ice);
  padding: 15px 0px 25px 0px;
  z-index: 999;
}

.tab-bar-mobile .menu-item {
  font-size: 25px;
}
</style>
